import cookie from 'js-cookie'
import { TFunction } from 'next-i18next'
import { IJobItem } from './@type'
import { ELanguage } from '@microfrontends/react-components'
import { slugify } from '../../helpers/string'
import { VNW_BASE_URL } from './const'

export const serviceCode = (item: IJobItem) => {
	let services: string[] = []
	item?.services?.forEach((service) => {
		services.push(service.serviceCode)
	})
	return services
}
export const formatSalary = (item: IJobItem, t: TFunction) => {
	let salaryText = ''
	if (item.isSalaryVisible) {
		if (item.salaryMin === 0 && item.salaryMax > 0)
			salaryText = t('Up to') + ' $' + item.salaryMax
		else if (item.salaryMin > 0 && item.salaryMax === 0)
			salaryText = t('From') + ' $' + item.salaryMin
		else if (item.salaryMin > 0 && item.salaryMax > 0)
			salaryText = '$' + item.salaryMin + ' - $' + item.salaryMax
		else salaryText = t('Negotiable')
	} else salaryText = t('Negotiable')
	return salaryText
}

export function getLastViewJobId(userId?: number) {
	const lastViewCookie = cookie.get('VNW_LAST_JOB_SEEN')
	if (!!lastViewCookie) {
		const lastViewJobData = decodeURIComponent(lastViewCookie).split(',')
		const jobId = lastViewJobData[0]
		const userViewJob = parseFloat(lastViewJobData[1])
		const isAnonymous = !userId || userViewJob === 0

		// not return job Id if logged in user is different than last viewed user
		if (!isAnonymous && userId !== userViewJob) {
			return
		}

		// other than that case, return job Id
		return jobId
	}
	return
}

export function renderUrlParams(params: any) {
	let queryString = ''
	let prefix = '?'
	const filledParams = Object.keys(params).filter((key) => params[key])
	filledParams.forEach((key, index) => {
		if (index !== 0 && filledParams.length > 0) {
			prefix = '&'
		}
		if (params[key]) {
			queryString += `${prefix}${key}=${encodeURIComponent(params[key])}`
		}
	})
	return queryString
}

export function generateRequest(
	filter: any[],
	page: number,
	limit: number,
	fields: string[],
	order?: any[],
	userId?: number
) {
	return {
		filter: filter,
		order: order,
		hitsPerPage: limit,
		page: page ?? 0,
		retrieveFields: fields,
		userId: userId ?? 0
	}
}

export interface IParamsGenerate {
	id?: string | number
	name?: string
	nameEn?: string
	language?: ELanguage
}

export interface IParamsJobFunctionGenerate {
	id?: string | number
	parentId?: number
	language?: ELanguage
	slug?: string
}

export function generateLocation({
	id,
	name,
	nameEn,
	language
}: IParamsGenerate) {
	return language === ELanguage.VI
		? `${VNW_BASE_URL}/viec-lam-${slugify(name)}-v${id}-vn`
		: `${VNW_BASE_URL}/${slugify(nameEn)}-jobs-v${id}-${language}`
}

export function generateCategories({
	id,
	parentId,
	language
}: IParamsJobFunctionGenerate) {
	return language === ELanguage.VI
		? `${VNW_BASE_URL}/viec-lam?g=${parentId}&j=${id}`
		: `${VNW_BASE_URL}/jobs?g=${parentId}&j=${id}`
}

export function BuildCategoriesLink({
	slug,
	language
}: IParamsJobFunctionGenerate) {
	return `${VNW_BASE_URL}/${slug}-${language == ELanguage.VI ? 'kv' : 'kw'}`
}

export function generateJobLevels({
	id,
	name,
	nameEn,
	language
}: IParamsGenerate) {
	return language === ELanguage.VI
		? `${VNW_BASE_URL}/${slugify(name)}-kv`
		: `${VNW_BASE_URL}/${slugify(nameEn)}-kw`
}

const TYPE_WORKING_OTHER = ['khác', 'other']
export function generateJobsTypeWorking({
	id,
	name,
	nameEn,
	language
}: IParamsGenerate) {
	if (TYPE_WORKING_OTHER.includes(name || '')) {
		return language === ELanguage.VI
			? `${VNW_BASE_URL}/viec-lam-l${id}-vn`
			: `${VNW_BASE_URL}/jobs-l${id}-${language}`
	}
	return language === ELanguage.VI
		? `${VNW_BASE_URL}/${slugify(name)}-kv`
		: `${VNW_BASE_URL}/${slugify(nameEn)}-kw`
}

export function generateTitle({ name, nameEn, language }: IParamsGenerate) {
	return language === ELanguage.VI
		? `Tìm việc làm tại ${name}`
		: `Jobs at ${nameEn}`
}
